// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"e21a85df","394":"028f7105","424":"c957378e","543":"693bb4e9","763":"01cb9dce","782":"51511632","854":"a83a8108"}[chunkId] + ".chunk.js";
};